(function () {
  // Cherry Hill cart drawer size control and size ladder helpers, 2026-08-14.
  //
  // The drawer previously used the PDP DESKTOP hover pills (.chs__pills /
  // .chs__pill) from sections/ch-pdp-bundle.liquid. Those are display:none
  // under 750px and sit absolutely positioned over the tile on hover. On a
  // 96px rack tile they rendered six roughly 15px targets that needed
  // horizontal scrolling to reach the last sizes. This module implements the
  // PDP MOBILE control instead: a 52x24 button that opens a bordered menu.
  //
  // The menu is position:fixed and placed from script. Both drawer scroll
  // containers, .minicart__entries (vertical) and .minicart__quickadd--row
  // (horizontal), sit in the containing block chain and would otherwise clip
  // an absolutely positioned menu.
  //
  // Loaded before ch-cart-quickadd.js in layout/theme.liquid so that file can
  // read window.CHCartSize at parse time. Both tags are defer, so order holds.

  var SIZE_LADDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL'];

  function escapeHtml(str) {
    return (str == null ? '' : String(str))
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function sizeRank(size) {
    var i = SIZE_LADDER.indexOf(size);
    return i === -1 ? SIZE_LADDER.length : i;
  }

  function productSizeOptionPosition(product) {
    if (!product.options) return -1;
    for (var i = 0; i < product.options.length; i++) {
      var name = (product.options[i].name || '').toLowerCase();
      if (name.indexOf('size') !== -1) return product.options[i].position;
    }
    return -1;
  }

  function sortedVariants(product, availableOnly) {
    var pos = productSizeOptionPosition(product);
    var list = (product.variants || []).filter(function (v) {
      return availableOnly ? v.available : true;
    });
    var withSize = list.map(function (v, i) {
      return { variant: v, size: pos > 0 ? v['option' + pos] : null, originalIndex: i };
    });
    withSize.sort(function (a, b) {
      var ra = sizeRank(a.size), rb = sizeRank(b.size);
      if (ra !== rb) return ra - rb;
      return a.originalIndex - b.originalIndex;
    });
    return withSize;
  }

  // Available variants only, canonical ladder order. Also the rack-eligibility
  // gate: a product with zero available variants is sold out and does not
  // belong in the rack at all.
  function availableSizedVariants(product) { return sortedVariants(product, true); }

  // EVERY sized variant, sold out ones included, same ordering. What the tile
  // and the cart line render. Out of stock sizes stay visible, greyed, marked
  // OUT by CSS, never hidden.
  function allSizedVariants(product) { return sortedVariants(product, false); }

  function entryLabel(entry) {
    return entry.size != null ? entry.size : entry.variant.title;
  }

  // Builds the whole control: the 52x24 button plus its menu. Mirrors the
  // markup sections/api__minicart.liquid renders for cart lines, so one set of
  // handlers drives both.
  function menuHtml(entries, selectedId, label, ariaLabel, disabled) {
    var opts = entries.map(function (entry) {
      var text = String(entryLabel(entry));
      var vid = String(entry.variant.id);
      var on = vid === String(selectedId);
      return '<button type="button" class="chs__opt' + (on ? ' on' : '') + '" role="option"' +
        ' aria-selected="' + (on ? 'true' : 'false') + '"' +
        ' data-v="' + escapeHtml(text) + '"' +
        ' data-variant-id="' + escapeHtml(vid) + '"' +
        (entry.variant.available ? '' : ' disabled') + '>' +
        escapeHtml(text) + '</button>';
    }).join('');
    return '<span class="minicart__szrow">' +
        '<button type="button" class="chs__size" data-szbtn aria-haspopup="listbox"' +
        ' aria-expanded="false" aria-label="' + escapeHtml(ariaLabel) + '"' +
        (disabled ? ' disabled' : '') + '>' +
          '<span class="chs__szlabel" data-szlabel>' + escapeHtml(label) + '</span>' +
          '<svg viewBox="0 0 10 6" aria-hidden="true" focusable="false">' +
            '<path d="M1 1l4 4 4-4" fill="none" stroke="#1a1a1a" stroke-width="1.4"/>' +
          '</svg>' +
        '</button>' +
        '<span class="chs__szmenu" data-szmenu role="listbox">' + opts + '</span>' +
      '</span>';
  }

  // Placed by measuring, then correcting. Lands on the button whether the
  // fixed containing block is the viewport or a transformed ancestor. Booster
  // slides the drawer in on a transform, which redefines that containing block.
  function place(row) {
    var btn = row.querySelector('[data-szbtn]');
    var menu = row.querySelector('[data-szmenu]');
    if (!btn || !menu) return;
    menu.style.top = '0px';
    menu.style.left = '0px';
    var m = menu.getBoundingClientRect();
    var b = btn.getBoundingClientRect();
    var top = b.bottom - m.top;
    if (b.bottom + m.height > window.innerHeight - 8) {
      top = b.top - m.top - m.height;
    }
    menu.style.left = (b.left - m.left) + 'px';
    menu.style.top = top + 'px';
  }

  function close(row) {
    if (!row) return;
    row.classList.remove('open');
    var btn = row.querySelector('[data-szbtn]');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  function closeAll(except) {
    Array.prototype.slice.call(document.querySelectorAll('.minicart__szrow.open')).forEach(function (row) {
      if (row !== except) close(row);
    });
  }

  function toggle(row) {
    var wasOpen = row.classList.contains('open');
    closeAll(row);
    if (wasOpen) { close(row); return; }
    place(row);
    row.classList.add('open');
    var btn = row.querySelector('[data-szbtn]');
    if (btn) btn.setAttribute('aria-expanded', 'true');
  }

  function select(row, opt) {
    Array.prototype.slice.call(row.querySelectorAll('.chs__opt')).forEach(function (o) {
      var on = o === opt;
      o.classList.toggle('on', on);
      o.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    var label = row.querySelector('[data-szlabel]');
    if (label) label.textContent = opt.getAttribute('data-v') || '';
  }

  // onPick(row, opt) runs after the label updates and the menu closes.
  function wire(row, onPick) {
    if (!row || row.getAttribute('data-szwired') === '1') return;
    row.setAttribute('data-szwired', '1');
    row.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var btn = t.closest('[data-szbtn]');
      if (btn) {
        e.preventDefault();
        if (btn.disabled) return;
        toggle(row);
        return;
      }
      var opt = t.closest('[data-variant-id]');
      if (!opt || opt.disabled) return;
      e.preventDefault();
      select(row, opt);
      close(row);
      if (typeof onPick === 'function') onPick(row, opt);
    });
  }

  // Capture phase, so a click inside a row reaches the row handler untouched
  // while any click elsewhere dismisses whatever is open.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('.minicart__szrow')) return;
    closeAll(null);
  }, true);
  document.addEventListener('scroll', function () { closeAll(null); }, true);
  window.addEventListener('resize', function () { closeAll(null); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') closeAll(null);
  });

  window.CHCartSize = {
    SIZE_LADDER: SIZE_LADDER,
    escapeHtml: escapeHtml,
    availableSizedVariants: availableSizedVariants,
    allSizedVariants: allSizedVariants,
    entryLabel: entryLabel,
    menuHtml: menuHtml,
    wire: wire,
    close: close,
    closeAll: closeAll
  };
})();
